import { render } from "./AppTeam.vue?vue&type=template&id=c71591e0&scoped=true"
import script from "./AppTeam.vue?vue&type=script&lang=js"
export * from "./AppTeam.vue?vue&type=script&lang=js"

import "./AppTeam.vue?vue&type=style&index=0&id=c71591e0&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71591e0"]])

export default __exports__